import { primitiveColors } from '../colors';
import { SemanticColors } from '../semantic-colors';

export const semanticColors = {
    background: {
        default: primitiveColors.gray[900],
        alternative: primitiveColors.gray[800],
        subtle: primitiveColors.gray[800],
        inverted: primitiveColors.gray.fff,
        disabled: primitiveColors.gray[850],
        accent: primitiveColors.defaRed,
        accentLight: primitiveColors.red[950],
        // Keep the old colors for charging and paused for now, they have changed in figma without notice (we need to discuss those first).
        charging: primitiveColors.defaBlue[500],
        paused: primitiveColors.defaDarkBlue[500],
        success: primitiveColors.green[400],
        attention: primitiveColors.urbanOrange[500],
        error: primitiveColors.red[500],
        banner: primitiveColors.defaBlue[500],
    },

    foreground: {
        default: primitiveColors.gray.fff,
        alternative: primitiveColors.gray[500],
        subtle: primitiveColors.gray[500],
        light: primitiveColors.gray.fff,
        darkDefa: primitiveColors.gray[850],
        disabled: primitiveColors.gray[700],
        accent: primitiveColors.defaRed,
        accentDark: primitiveColors.defaRed,
        secondaryControls: primitiveColors.defaRed,
        // Keep the old color for charging for now, it has changed in figma without notice (we need to discuss those first).
        charging: primitiveColors.defaBlue[500],
        success: primitiveColors.green[400],
        attention: primitiveColors.urbanOrange[500],
        error: primitiveColors.red[500],
        iosDetails: primitiveColors.gray[800],
        solar: primitiveColors.solar,
    },

    effects: {
        hover: 'rgba(0, 0, 0, 0.1)',
        pressed: 'rgba(0, 0, 0, 0.2)',
    },

    border: {
        default: primitiveColors.gray[500],
        alternative: primitiveColors.gray[850],
        subtle: primitiveColors.gray[800],
        light: primitiveColors.gray.fff,
        accent: primitiveColors.red[500],
        success: primitiveColors.green[500],
        attention: primitiveColors.urbanOrange[500],
        error: primitiveColors.red[500],
    },

    status: {
        default: {
            background: primitiveColors.gray[200],
            border: primitiveColors.gray[400],
            text: primitiveColors.gray['000'],
        },
        info: {
            background: primitiveColors.electricBlue[200],
            border: primitiveColors.electricBlue[500],
            text: primitiveColors.electricBlue[900],
        },
        success: {
            background: primitiveColors.green[100],
            border: primitiveColors.green[300],
            text: primitiveColors.green[800],
        },
        danger: {
            background: primitiveColors.red[100],
            border: primitiveColors.red[200],
            text: primitiveColors.red[700],
        },

        attention: {
            background: primitiveColors.urbanOrange[200],
            border: primitiveColors.urbanOrange[500],
            // Differs from Figma (which uses black). Aligned with the other
            // status variants, which use a deep shade of their own hue for
            // text. Update Figma to match.
            text: primitiveColors.urbanOrange[700],
        },
    },
} satisfies SemanticColors;
